import axios from 'axios';
import {toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const util = require('../utils/index');
const process = require('../env');

const getCredentials = () => {
  const userLogged = util.getUser();

  const credentials = {
    username: userLogged.login,
    password: userLogged.senha
  }

  return credentials;
}


export const registrarResponsavelApi = async (formValue) => {
  try{
      const response = await axios.post(`${process.env.URL}/severalResponsible/createSeveralResponsible`, formValue, {
        auth: getCredentials()
      })
  
      if (response.status === 200){
        return true;
      }

    }catch(e){
     toast.error(e.response.data['message']);
    }
  return false;
}


export const listarResponsavelApi = async (body) => {
  try{
      const response = await axios.post(`${process.env.URL}/severalResponsible/getSeveralResponsible`, body, {
        auth: getCredentials()
      })
      const users = response.data
      if (response.status === 200){
        return users;
      }
      

    }catch(e){
     toast.error(e.response.data['message']);
    }
  return false;
}

export const pegarResponsavelApi = async (id) => {
  try{
      const response = await axios.post(`${process.env.URL}/severalResponsible/getseveralResponsibleByID`, id, {
        auth: getCredentials()
      })
      const user = response.data
      if (response.status === 200){
        return user;
      }
      

    }catch(e){
     toast.error(e.response.data['message']);
    }
  return false;
}

export const pegarResponsavelApiRA = async (id) => {
  try{
      console.log(id)
      const response = await axios.post(`${process.env.URL}/severalResponsible/getseveralResponsibleByIDRA`, id, {
        auth: getCredentials()
      })
      const user = response.data
     
      if (response.status === 200){
        return user;
      }
      

    }catch(e){
     toast.error(e.response.data['message']);
    }
  return false;
}

export const pegarFilialPorResponsavel = async (id) => {
  try{
      const response = await axios.post(`${process.env.URL}/severalseveralResponsible/getBranchByseveralResponsible`, id, {
        auth: getCredentials()
      })
      const user = response.data
      if (response.status === 200){
        return user;
      }
      

    }catch(e){
     toast.error(e.response.data['message']);
    }
  return false;
}

export const atualizarResponsavelApi = async (formValue) => {
  try{
      const response = await axios.put(`${process.env.URL}/severalResponsible/updateseveralResponsible`, formValue, {
        auth: getCredentials()
      })
      if (response.status === 200){
        return true;
      }
      

    }catch(e){
     toast.error(e.response.data['message']);
    }
  return false;
}

export const excluirResponsavelApi = async (formValue) => {
  try{
      const response = await axios.post(`${process.env.URL}/severalResponsible/deleteseveralResponsible`, formValue, {
        auth: getCredentials()
      })
      if (response.status === 200){
        return true;
      }
      

    }catch(e){
     toast.error(e.response.data['message']);

    }
  return false;
}